import sha256 from "/imports/utils/functions/sha256";

const hashPassword = password => {
  return sha256(password);
};

export default hashPassword;
